import React, {Fragment, useMemo} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import SqftStore from "../../../../../canvas/store/sqftStore";
import config from "../../../../../canvas/store/sqftConfig";
import Radius from "../../../../../canvas/core/controls/radius";
import {getCurrentLayout} from "../../../../../../../appLayout";
import {getNavItems} from "../../../../../../helpers/sqftHelperUi";
import FeatureName from "../../../../../../../visComponents/featureName";
import {MEASURE_UNITS} from "../../../../../../constants";
import sqftConfig from "../../../../../canvas/store/sqftConfig";
//import sqftConfig from "../../../../../canvas/store/sqftConfig";

const SqftNavRadius = (props) => {
  const {visualizersLoaded, measureUnit} = props;
  const [activeItemIndex, setActiveItemIndex] = React.useState(0);
  const featureGroupName = 'radius';
  const staticLowesFeatureGroupName = 'radius';
  const staticLowesFeatureName = 'Radii Corners (over 3 inches)';

  const layout = getCurrentLayout();
  let featureGroup;
  let isRadiiFeatures;
  if (visualizersLoaded.length) {
    featureGroup = layout.getSubPartFromQtCategories(featureGroupName);
  }

  const radiiNavItems = useMemo(() => {
    if (visualizersLoaded.length) {
      let radiiNavItems = getNavItems(featureGroup, "", {}, false, true);
      radiiNavItems = radiiNavItems.filter((navItem) => {
        return parseInt(navItem.part.dbFeature.sharedFeatureName)
      });
      radiiNavItems.sort((a, b) => parseInt(a.part.dbFeature.sharedFeatureName) - parseInt(b.part.dbFeature.sharedFeatureName));

      return radiiNavItems
    }
    return []
  }, [visualizersLoaded, featureGroup]);

  const staticFeature = useMemo(() => {
    if (visualizersLoaded.length) {
      const staticFeatureGroup = layout.getSubPartFromQtCategories(staticLowesFeatureGroupName);
      return getNavItems(staticFeatureGroup, staticLowesFeatureName, {}, false, true);
    }
    return []
  }, [layout, visualizersLoaded]);

  isRadiiFeatures = !!featureGroup && radiiNavItems.length > 0;

  const getHardcodedRadii = () => {
    const radii = [];
    let i = 0;
    const maxRadius = 18;
    while (++i <= maxRadius) radii.push(i);

    return radii
  }

  const getHardcodedRadiiMitered = () => {
    const radii = [];
    let i = 0;
    const maxRadius = 400;
    while (i < maxRadius) {
      i += 25;
      radii.push(i);
    }

    return radii
  }

  const radiiToDisplay = useMemo(() => {
    if (visualizersLoaded.length) {
      if (isRadiiFeatures) {
        return radiiNavItems
      } else {
        switch (measureUnit) {
          case MEASURE_UNITS.Metric:
            return getHardcodedRadiiMitered();
          case MEASURE_UNITS.Imperial:
          default:
            return getHardcodedRadii();
        }
      }
    }
    return []
  }, [visualizersLoaded, isRadiiFeatures, radiiNavItems, measureUnit]);

  const handleButtonClick = function(e, value, navItem) {
    const getRadiusFeatureId = (navItem, value) => {
      //This hardcode is for Lowes
      if (staticFeature.length > 0 && value > 3) {
        return staticFeature[0].part.dbFeature.id
      }
      return navItem.part ? navItem.part.dbFeature.id : null
    }
    void e;
    const radiiValue = value / sqftConfig.getMeasureMultiplier();
    setActiveItemIndex(radiiValue);
    deregisterEvents();
    SqftStore.radius.angle = 0;
    SqftStore.radius.arcLength = radiiValue;
    SqftStore.radius.featureId = getRadiusFeatureId(navItem, radiiValue);

    Radius.handleButtonClick(radiiValue);
    console.log("radiiValue", radiiValue);
  };

  const deregisterEvents = function() {
    //elements.navRadius.removeClass('steps-scope-config-button-selected');
    SqftStore.radius.arcLength = 0;
    SqftStore.radius.angle = 0;
    SqftStore.radius.feature = null;
    config.highlight.points = false;
  };

  const imperialRadii = getHardcodedRadii();

  return (
    <Fragment>
      {radiiToDisplay.map((radius, index) => {
        const value = isRadiiFeatures ? parseInt(radius.part.dbFeature.sharedFeatureName) : radius;
        const className = activeItemIndex === value ? 'lightbox-option-rectangular lightbox-option-selected' : 'lightbox-option-rectangular';

        return (
          <div className={className} key={index}
               onClick={(e) => handleButtonClick(e, value, radius)}>
            <div className={"lightbox-edge-graph lightbox-edge-graph-R" + imperialRadii[index] * 10}/>
            <div className="lightbox-description-text-rectangular">
              {
                isRadiiFeatures
                  ? <FeatureName feature={radius.part} />
                  : <Fragment>
                    <span data-value="radius">{value}{sqftConfig.getMeasureUnitPostfix(true)} </span>
                    <FormattedMessage id="sqft.navigation.radius.radiusItem"/>
                  </Fragment>
              }

            </div>
          </div>
        )
      })}
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {visualizersLoaded} = store.serverState;
  const {measureUnit} = store.sqftState;
  return {
    menuOpened,
    visualizersLoaded,
    measureUnit,
  };
};

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavRadius);
